export const GET_states = ({ states }) => states
export const GET_employeesDepartments = ({ employeesDepartments }) => employeesDepartments
export const GET_employeesFunctions = ({ employeesFunctions }) => employeesFunctions
export const GET_employeesRoles = ({ employeesRoles }) => employeesRoles
export const GET_maritalStatus = ({ maritalStatus }) => maritalStatus
export const GET_genders = ({ genders }) => genders
export const GET_monthsOfTheYear = ({ monthsOfTheYear }) => monthsOfTheYear
export const GET_employeePaycheck = ({ employeePaycheck }) => employeePaycheck
export const GET_departmentById =
  ({ departments }) =>
  (id) => {
    return departments.find((dp) => dp.id == id)
  }
